// 费用报销管理页面路由
const FybxApply = () => import('@/views/cwgl/fybx/fybxApply.vue');
const FybxApprove = () => import('@/views/cwgl/fybx/flow/flow_fybxApprove.vue');
const FybxFlowApply = () => import('@/views/cwgl/fybx/flow/flow_fybxApply.vue');
const FybxFlowHandle = () => import('@/views/cwgl/fybx/flow/flow_fybxHandle.vue');
const FybxFlowCashier = () => import('@/views/cwgl/fybx/flow/flow_fybxCashier.vue');
const FybxGl = () => import('@/views/cwgl/fybxgl/fybxgl.vue');
const FybxFinalHandle = () => import('@/views/cwgl/fybx/flow/flow_fybxFinalHandle.vue');
const FybxBl = () => import('@/views/cwgl/fybxbl/index.vue');

export default [
  {
    path: '/cwgl/fybx/apply/',
    name: 'fybxApply',
    meta: {
      title: '费用报销申请',
      path: ['费用管理', '费用报销申请'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxApply
  },
  {
    path: '/cwgl/fybx/approve',
    name: 'fybxApprove',
    meta: {
      title: '费用报销审批',
      path: ['费用管理', '费用报销审批'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxApprove
  },
  {
    path: '/cwgl/fybx/flow/apply',
    name: 'fybxFlowApply',
    meta: {
      title: '费用报销工作流申请',
      path: ['费用管理', '费用报销工作流申请'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxFlowApply
  },
  {
    path: '/cwgl/fybx/flow/handle',
    name: 'fybxFlowHandle',
    meta: {
      title: '费用报销处理',
      path: ['费用管理', '费用报销处理'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxFlowHandle
  },
  {
    path: '/cwgl/fybx/flow/cashier',
    name: 'fybxFlowCashier',
    meta: {
      title: '费用报销出纳',
      path: ['费用管理', '费用报销出纳'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxFlowCashier
  },
  {
    path: '/cwgl/fybx/gl',
    name: 'fybxGl',
    meta: {
      title: '费用报销管理',
      path: ['费用管理', '费用报销管理'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxGl
  },
  {
    path: '/cwgl/fybx/flow/finalHandle',
    name: 'fybxFinalHandle',
    meta: {
      title: '费用报销最终处理',
      path: ['费用管理', '费用报销最终处理'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxFinalHandle
  },
  {
    path: '/cwgl/fybx/bl',
    name: 'fybxBl',
    meta: {
      title: '费用报销补录',
      path: ['财务管理', '费用报销补录'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: FybxBl
  }
];
